<template>
  <b-link :href="link" target="_blank">
    <b-img :src="img" fluid />
  </b-link>
</template>

<script>
export default {
  props: {
    link: {
      type: String
    },
    img: {
      type: String
    }
  }
};
</script>
